//
//
//
//
//
//
//
//
//
//

export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      logo: require("@/assets/logo/".concat(process.env.VUE_APP_APP_LOGO))
    };
  },
  computed: {
    leftNavBg: function leftNavBg() {
      return this.$store.state.settings.leftNavBg;
    }
  }
};